'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.passwordResetRequestSubmitted = exports.passwordResetRequestFailed = exports.passwordResetRequested = undefined;

var _passwordService = require('../../password/passwordService');

var _forgottenPasswordConstants = require('./forgottenPasswordConstants');

var _errorConstants = require('../../../../common/error/errorConstants');

// Constants
var passwordResetRequested = exports.passwordResetRequested = function passwordResetRequested(email) {
    return {
        type: _forgottenPasswordConstants.PASSWORD_RESET_REQUESTED,
        email: email
    };
}; // Services
var passwordResetRequestFailed = exports.passwordResetRequestFailed = function passwordResetRequestFailed() {
    var errorData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        type: _forgottenPasswordConstants.PASSWORD_RESET_REQUEST_FAILED,
        error: {
            code: errorData.code || errorData.status
        }
    };
};

var passwordResetRequestSubmitted = exports.passwordResetRequestSubmitted = function passwordResetRequestSubmitted(_ref) {
    var email = _ref.email;
    return function (dispatch) {
        return (0, _passwordService.reset)(email).then(function (res) {
            return dispatch(passwordResetRequested(email));
        }).catch(function (err) {
            var error = err.response && err.response.data && err.response.data.error;

            // On validation errors respond with a structure that the form can react to
            if (error && error.code === _errorConstants.RESPONSE_ERROR.VALIDATION_FAILURE) {
                return Promise.reject(error.details);
            }

            dispatch(passwordResetRequestFailed(err.response));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/forgottenPassword/forgottenPasswordActions.js
// module id = 1680
// module chunks = 0